import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { CameraIcon, ChatBubbleInstaIcon, HeartIcon, MoreHorizIcon, SendIcon } from 'images'

export function ReelsPreview({ data, onLoaded, placement, label }) {
  const bodyRef = useRef(null)
  const [isLongText, setIsLongText] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (bodyRef.current) {
      setIsLongText(bodyRef.current.scrollHeight > bodyRef.current.clientHeight)
    }
  }, [])

  if (!data) return null

  const { page_name, profile_picture_url, body, media, call_to_action, fb_info_loading } = data
  const isVideo = media?.type === 'video' || (media?.url && media.url.endsWith('.mp4'))

  return (
    <div className="feature-card-container">
      <div className="feature-card">
        <div className="placement-ig-reels">
          {/* Media Layer */}
          <div className="placement-ig-reels__media">
            {isVideo ? (
              <video
                src={media.url}
                autoPlay
                loop
                muted
                playsInline
                className="media"
                onLoadedData={onLoaded}
              />
            ) : (
              <img
                src={media.url}
                alt={media.filename || 'ad creative'}
                className="media"
                onLoad={onLoaded}
              />
            )}
          </div>

          {/* Progress Bar */}
          <div className="placement-ig-reels__progress">
            <div className="placement-ig-reels__progress-fill" />
          </div>

          {/* Top title bar (Reels + Camera) */}
          <div className="placement-ig-reels__container">
            <div className="placement-ig-reels__main-title">
              <h4>
                <strong>Reels</strong>
              </h4>
              <div>
                <CameraIcon width={25} />
              </div>
            </div>

            {/* Info and actions */}
            <div className="placement-ig-reels__info">
              <div className="placement-ig-reels__info-row">
                <div className="placement-ig-reels__info-main">
                  <div className="placement-ig-reels__avatar-wrap">
                    {profile_picture_url ? (
                      <img
                        alt={page_name}
                        className="placement-ig-reels__profile_picture"
                        src={profile_picture_url}
                      />
                    ) : (
                      <div
                        className={cn('placement-ig-reels__icon', { loading: fb_info_loading })}
                      />
                    )}
                  </div>
                  {page_name ? (
                    <p className="placement-ig-reels__title">
                      {page_name}
                      <span className="subtitle">Sponsored</span>
                    </p>
                  ) : fb_info_loading ? (
                    <div className="fb-error loading" />
                  ) : (
                    <div className="fb-error">Page Info</div>
                  )}
                </div>
                <div className="placement-ig-reels__interactions">
                  <span>
                    <HeartIcon />
                  </span>
                  <span>
                    <ChatBubbleInstaIcon />
                  </span>
                  <span>
                    <SendIcon />
                  </span>
                  <span>
                    <MoreHorizIcon />
                  </span>
                </div>
              </div>
              <div className="placement-ig-reels__caption-row">
                <span ref={bodyRef} className={showMore ? 'text' : 'text_clipped'}>
                  {body ||
                    'Your ad copy goes here. This is a preview of how it will look in Instagram Reels.'}
                </span>
                {isLongText && (
                  <span className="more" onClick={() => setShowMore((v) => !v)}>
                    {showMore ? 'less' : 'more'}
                  </span>
                )}
              </div>
              <div className="placement-ig-reels__cta-row">
                <button className="placement-ig-reels__order-now">
                  <div>{t(`Recommendations.campaign.setup.call_to_action.${call_to_action}`) || 'Learn More'}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="feature-card-label">
        <span>{placement}</span>
        <span>{label}</span>
      </div>
    </div>
  )
}

ReelsPreview.propTypes = {
  data: PropTypes.object,
  onLoaded: PropTypes.func,
}

export default ReelsPreview
